import http from '../../../api/axios';
import { apiUrl } from '../../../api/apiUrl';
import { Values } from '../../../forms/CurrencyRates/CurrencyRatesForm.types';
import { handleApiErrors } from '../../../api/apiErrorHandler';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useCurrentCompany } from '../../../hooks/useCompany';
import { paths } from '../../RouterContainer';
import { CurrencyRatesForm } from '../../../forms/CurrencyRates/CurrencyRatesForm';
import { useTranslation } from '../../../context/translationContext';
import { COMPANY_TABS } from '../Company/UserCompaniesUpdatePage';
import { useBreadcrumbs } from '../../../hooks/useBreadcrumbs';
import { useEffect } from 'react';
import { useLoading } from '../../../context/loadingContext';

/**
 * Component to create currency rates for company
 */
export const CurrencyRatesCreatePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { companyId } = useParams();
  const { company } = useCurrentCompany();
  const { setBreadcrumbs } = useBreadcrumbs();
  const { startLoading, stopLoading } = useLoading();
  const isCurrent = window.location.pathname.includes(`current`);
  useEffect(() => {
    setBreadcrumbs([
      {
        path: `${paths.MY_COMPANIES}`,
        name: 'navigation.my-companies',
      },
      {
        path: `${paths.MY_COMPANIES}/edit/${isCurrent ? `current` : companyId}`,
        name: 'navigation.company-setting',
      },
      {
        path: `${paths.MY_COMPANIES}/${isCurrent ? `current` : companyId}/${
          paths.COMPANY_CURRENCY_RATES
        }/create`,
        name: 'navigation.currency-rate-create',
      },
    ]);
  }, []);

  /**
   * Back button action
   */
  const handleOnBack = () =>
    navigate(`/${paths.MY_COMPANIES}/edit/${isCurrent ? `current` : companyId}`, {
      state: { tab: COMPANY_TABS.CURRENCY_RATES },
    });

  /**
   * Handles create action for new currency rate
   * @param values form data
   */
  const handleSubmit = async (values: Values) => {
    if (!company) return;
    try {
      startLoading();
      const response = await http.apiPost({
        url: apiUrl.COMPANY_CURRENCY_RATES_CREATE,
        data: { ...values, companyId: company.id },
      });
      if (response?.status === 201) {
        stopLoading();
        toast.success('Success!');
        navigate(
          `/${paths.MY_COMPANIES}/${isCurrent ? `current` : companyId}/${
            paths.COMPANY_CURRENCY_RATES
          }/edit/${response.data?.id}`,
        );
      }
    } catch (err) {
      stopLoading();
      handleApiErrors(err);
    }
  };

  return (
    <div className="w-1/4	space-y-8">
      <h1 className="text-3xl font-bold">{t('page.currency-rates.headline-create')}</h1>
      <CurrencyRatesForm onSubmit={handleSubmit} onBack={handleOnBack} />
    </div>
  );
};
